import { useEffect, useState } from 'react';
import { EventBus } from '@campus/core';
import { useMembersStore } from '../people/membersStore.js';
import { Button, Icon } from '../ds/index.js';

/**
 * Le titulaire d'un bureau partage son tableau avec soi (on est dans son
 * bureau) : « Ouvrir » l'affiche ; il se ferme quand on sort du bureau ou que
 * le partage est retiré (WhiteboardHost).
 */
export function BoardSharePrompt() {
  const [share, setShare] = useState<{ itemId: string; ownerUserId?: string; boardName?: string } | null>(null);
  const members = useMembersStore((s) => s.members);
  useEffect(() => {
    const onShared = (e: { itemId: string; ownerUserId?: string; boardName?: string }) => setShare(e);
    const onGone = ({ itemId }: { itemId: string }) => setShare((s) => (s?.itemId === itemId ? null : s));
    EventBus.on('board:shared', onShared);
    EventBus.on('board:unshared', onGone);
    EventBus.on('board:closed', onGone);
    return () => {
      EventBus.off('board:shared', onShared);
      EventBus.off('board:unshared', onGone);
      EventBus.off('board:closed', onGone);
    };
  }, []);
  if (!share) return null;
  const owner = (share.ownerUserId && members.get(share.ownerUserId)?.displayName) || 'Le titulaire du bureau';
  return (
    <div className="pl-float-bottom">
      <div className="pl-pop" role="status" style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 10px 10px 14px', fontSize: 13 }}>
        <Icon name="edit" size={16} className="pl-menu-icon" />
        <span style={{ flex: 1 }}><strong>{owner}</strong> partage son tableau avec toi, tant que tu restes dans son bureau.</span>
        <Button variant="secondary" size="sm" onClick={() => setShare(null)}>Plus tard</Button>
        <Button variant="primary" size="sm" onClick={() => {
          EventBus.emit('ui:board-open', { itemId: share.itemId, name: `${share.boardName ?? 'Tableau'} de ${owner}` });
          setShare(null);
        }}>Ouvrir</Button>
      </div>
    </div>
  );
}
